import { z } from "zod";

export const RateSchema = z.object({
  rate: z.number(),
  unit: z.union([z.enum(["hour", "day"]), z.undefined()]),
});
